// Copy helper that degrades gracefully where the async Clipboard API is missing
// (non-secure origins, older/embedded browsers) instead of throwing on click.
export const copyText = (text) => {
  if (navigator.clipboard?.writeText) {
    return navigator.clipboard.writeText(text).catch(() => {});
  }
  try {
    const el = document.createElement('textarea');
    el.value = text;
    el.style.position = 'fixed';
    el.style.opacity = '0';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  } catch { /* clipboard unavailable — copy just no-ops */ }
  return Promise.resolve();
};

export default copyText;
